import React from 'react';
import logo_pop from '../assets/images/logo-pop.png';
import payment_error from '../assets/images/payment_error.png';
import EDSFooter from '../components/EDSFooter';

const Platnosc_nieudana = () => {
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content responsive-padding margin-top-32">
                <div className="half-half half-half--text-to-left">
                    <main className="">
                        <div>
                            <section className="margin-top-64 margin-bottom-32">
                                <h2 className="h2">Płatność nieudana.</h2>
                                <p className="margin-top-32">Twoja płatność się nie powiodła.</p>
                                <a
                                    href=""
                                    className="btn-primary-responsive btn-primary-responsive--medium margin-top-16"
                                >
                                    Ponów płatność
                                </a>
                                <h2 className="h2 margin-top-64">INFOLINIA</h2>
                                <p className="margin-top-8">czynna od poniedziałku do piątku</p>
                                <p>w godzinach 9:00 - 17:00</p>
                                <p className="margin-top-16">tel.: 601 20 20 20</p>
                                <p>e-mail: studio@egurrola.pl</p>
                                <a
                                    href=""
                                    className="btn-secondary-responsive btn-secondary-responsive--medium margin-top-64"
                                >
                                    Wróć do strony głównej
                                </a>
                            </section>
                        </div>
                    </main>
                    <div className="decorative">
                        <img
                            src={payment_error}
                            alt="Płatność nieudana"
                            className="decorative__img"
                        />
                    </div>
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Platnosc_nieudana;
